import React from 'react'

const Footer = () => {
    return (
        <div>
             {/* <!-- Footer start --> */}
            <footer className="footer overview-bgi">
                <div className="container footer-inner">
                    <div className="row">
                        <div className="col-xl-4 col-lg-3 col-md-6 col-sm-6">
                            <div className="footer-item clearfix">
                                <img src="./img/logos/black-logo.PNG" alt="logo" className="f-logo"/>
                                <div className="s-border"></div>
                                <div className="m-border"></div>
                                <div className="text">
                                    <p>En WTI Services, nos esforzamos por brindar un servicio de excelencia en tramites de importacion y exportacion.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                            <div className="footer-item clearfix">
                                <h4>
                                    Contacto
                                </h4>
                                <div className="s-border"></div>
                                <div className="m-border"></div>
                                <ul className="contact-info">
                                    <li>
                                        <i className="flaticon-pin"></i>Plaza Bonita Av. Tecnologico 5350 Local 10
                                    </li>
                                    <li>
                                        <i className="flaticon-mail"></i><a href="mailto:sales@hotelempire.com">info@wtiserviciosaduanales.com</a>
                                    </li>
                                    <li>
                                        <i className="flaticon-phone"></i><a href="tel:+526564415210">+52 656 441 5210</a>
                                    </li>
                                    <li>
                                        <i className="flaticon-fax"></i>+52 656 441 5210
                                    </li>
                                </ul>
                            </div>
                        </div>
                    
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                            <div className="footer-item clearfix">
                                <h4>Subscribete</h4>
                                <div className="s-border"></div>
                                <div className="m-border"></div>
                                <div className="Subscribe-box">
                                    <p>Y recibe en tu correo ofertas y promociones cada mes.</p>
                                    <form className="form-inline" action="#" method="GET">
                                        <input type="text" className="form-control mb-sm-0" id="inlineFormInputName3" placeholder="Correo Electronico"/>
                                        <button type="submit" className="btn"><i className="fa fa-paper-plane"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sub-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <p className="copy">© 2021 <a href="http://gorilla-labs.com/">Gorilla-Labs.</a> All Rights Reserved.</p>
                            </div>
                            <div className="col-lg-6">
                                <div className="social-list-2">
                                    <ul>
                                        <li><a href="#" className="facebook-bg"><i className="fa fa-facebook"></i></a></li>
                                        <li><a href="#" className="twitter-bg"><i className="fa fa-twitter"></i></a></li>
                                        <li><a href="#" className="google-bg"><i className="fa fa-google-plus"></i></a></li>
                                        <li><a href="#" className="linkedin-bg"><i className="fa fa-linkedin"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {/* <!-- Footer end --> */}            
        </div>
    )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Global/Footer.jsx